import { Helmet } from "react-helmet";
import { CheckoutComponentChatAttibutesType } from "../../types/builder";

const Intercom: React.FC<
  Pick<CheckoutComponentChatAttibutesType, "accountId">
> = ({ accountId }) => {
  return (
    <Helmet>
      <script
        src={`https://widget.intercom.io/widget/${accountId}`}
        async
      ></script>
    </Helmet>
  );
};

export default Intercom;
